.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.muted {
  margin: 0;
  padding: var(--sp-7) 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
  text-align: center;
}

.error {
  margin: 0;
  padding: var(--sp-4);
  background: var(--error-bg);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  color: var(--error);
  font-size: var(--fs-sm);
}

/* Переключатель статусов липнет к верху: очередь длинная, а перейти в другой
   статус нужно с любой её высоты. */
.bar {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  gap: var(--sp-3);
  padding: var(--sp-4) 0;
  background: var(--bg);
  border-bottom: var(--bw) solid var(--border);
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  color: var(--text-2);
  font-size: var(--fs-sm);
  cursor: pointer;
}

.tab:hover {
  background: var(--surface-2);
  color: var(--text);
}

.tabOn {
  background: var(--surface-2);
  border-color: var(--border-strong);
  color: var(--text);
  font-weight: 600;
}

.count {
  color: var(--text-3);
  font-variant-numeric: tabular-nums;
}

.tabOn .count {
  color: var(--text-2);
}

/* ── Очередь ─────────────────────────────────────────────────────────────── */

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

/* Текст показывается целиком и с переносами: решение принимают по нему, и
   обрезать его в очереди значит заставить модератора открывать каждую строку. */
.text {
  margin: 0;
  font-size: var(--fs-md);
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
  font-size: var(--fs-sm);
}

.tag {
  padding: var(--sp-1) var(--sp-3);
  background: var(--surface-2);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-xs);
}

.author {
  color: var(--text-2);
}

.date {
  color: var(--text-3);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
}

/* Удаление отодвинуто от решений: «опубликовать» и «удалить» рядом — это
   промах ценой чужого текста, восстановить который неоткуда. */
.spacer {
  flex: 1 1 auto;
}
